(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-fbt-block"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fbt-compact')) {
    class FbtCompact extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.addEventListener('change', this.handleChange.bind(this));
        this.addEventListener('click', this.handleClick.bind(this));
      }

      handleChange(event) {
        const select = event.target.closest('.fbt-mini__variant');
        if (!select || !this.contains(select)) return;

        const card = select.closest('.fbt-mini__card');
        const option = select.options[select.selectedIndex];
        const button = card?.querySelector('.fbt-mini__add');
        const price = card?.querySelector('.fbt-mini__price');
        const compare = card?.querySelector('.fbt-mini__compare');

        if (button) button.dataset.variantId = select.value;
        if (price) price.textContent = option.dataset.price || '';

        if (compare) {
          const comparePrice = option.dataset.comparePrice || '';
          compare.textContent = comparePrice;
          compare.classList.toggle('is-hidden', !comparePrice);
        }
      }

      async handleClick(event) {
        const button = event.target.closest('.fbt-mini__add');
        if (!button || !this.contains(button) || button.disabled) return;

        const card = button.closest('.fbt-mini__card');
        const status = card?.querySelector('.fbt-mini__status');
        const productTitle = card?.querySelector('.fbt-mini__title')?.textContent?.trim() || 'Item';
        const variantId = button.dataset.variantId;

        if (!card || !variantId) return;

        button.disabled = true;
        button.classList.add('is-loading');
        button.classList.remove('is-error');
        button.setAttribute('aria-busy', 'true');

        try {
          await this.addVariant(variantId);

          if (status) status.textContent = 'Added to cart';
          this.showToast({
            type: 'success',
            title: 'Added to cart',
            message: `${productTitle} was added successfully.`,
          });
          this.removeCard(card);
        } catch (error) {
          console.error('[Frequently Bought Together]', error);

          const errorMessage = error?.message || 'Could not add to cart';

          if (status) status.textContent = errorMessage;
          this.showToast({
            type: 'error',
            title: 'Could not add item',
            message: errorMessage,
            duration: 5000,
          });
          button.classList.add('is-error');
          button.title = errorMessage;
          button.disabled = false;

          window.setTimeout(() => {
            button.classList.remove('is-error');
            button.title = 'Add to cart';
          }, 2200);
        } finally {
          button.classList.remove('is-loading');
          button.removeAttribute('aria-busy');
        }
      }

      showToast({ type = 'success', title = '', message = '', duration = 3600 } = {}) {
        let region = document.querySelector('.fbt-toast-region');

        if (!region) {
          region = document.createElement('div');
          region.className = 'fbt-toast-region';
          region.setAttribute('aria-label', 'Cart notifications');
          document.body.appendChild(region);
        }

        // Keep the notification area tidy if a shopper clicks several products quickly.
        while (region.children.length >= 3) {
          region.firstElementChild?.remove();
        }

        const toast = document.createElement('div');
        toast.className = `fbt-toast fbt-toast--${type === 'error' ? 'error' : 'success'}`;
        toast.style.setProperty('--fbt-toast-duration', `${duration}ms`);
        toast.setAttribute('role', type === 'error' ? 'alert' : 'status');
        toast.setAttribute('aria-live', type === 'error' ? 'assertive' : 'polite');
        toast.setAttribute('aria-atomic', 'true');

        const icon = document.createElement('span');
        icon.className = 'fbt-toast__icon';
        icon.setAttribute('aria-hidden', 'true');
        icon.innerHTML = type === 'error'
          ? '<svg viewBox="0 0 20 20" focusable="false"><path d="M10 3.25a6.75 6.75 0 1 1 0 13.5 6.75 6.75 0 0 1 0-13.5Zm0 3.1v4.2m0 2.6h.01" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>'
          : '<svg viewBox="0 0 20 20" focusable="false"><path d="m5.5 10.2 2.8 2.8 6.2-6.2" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';

        const content = document.createElement('div');
        content.className = 'fbt-toast__content';

        const heading = document.createElement('p');
        heading.className = 'fbt-toast__title';
        heading.textContent = title;
        content.appendChild(heading);

        if (message) {
          const body = document.createElement('p');
          body.className = 'fbt-toast__message';
          body.textContent = message;
          content.appendChild(body);
        }

        const close = document.createElement('button');
        close.type = 'button';
        close.className = 'fbt-toast__close';
        close.setAttribute('aria-label', 'Dismiss notification');
        close.innerHTML = '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="m6 6 8 8m0-8-8 8" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';

        const progress = document.createElement('span');
        progress.className = 'fbt-toast__progress';
        progress.setAttribute('aria-hidden', 'true');

        toast.append(icon, content, close, progress);
        region.appendChild(toast);

        let timeoutId;
        let removed = false;

        const dismiss = () => {
          if (removed) return;
          removed = true;
          window.clearTimeout(timeoutId);
          toast.classList.add('is-leaving');

          const removeToast = () => toast.remove();
          toast.addEventListener('animationend', removeToast, { once: true });
          window.setTimeout(removeToast, 240);
        };

        close.addEventListener('click', dismiss);
        timeoutId = window.setTimeout(dismiss, duration);
      }

      async addVariant(variantId) {
        if (window.Shopify?.actions?.updateCart) {
          const result = await window.Shopify.actions.updateCart({
            lines: [
              {
                merchandiseId: String(variantId),
                quantity: 1,
              },
            ],
          });

          if (result?.userErrors?.length) {
            throw new Error(result.userErrors[0].message || 'Could not add to cart');
          }

          return result;
        }

        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            items: [
              {
                id: Number(variantId),
                quantity: 1,
              },
            ],
          }),
        });

        const data = await response.json();

        if (!response.ok) {
          throw new Error(data?.description || data?.message || 'Could not add to cart');
        }

        await this.refreshLegacyCartState(root);
        return data;
      }

      async refreshLegacyCartState(root) {
        try {
          const response = await fetch(`${root}cart.js`, {
            headers: { Accept: 'application/json' },
          });

          if (!response.ok) return;

          const cart = await response.json();

          document.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: cart,
                sourceId: 'fbt-compact',
              },
            })
          );

          document.documentElement.dispatchEvent(
            new CustomEvent('cart:refresh', { bubbles: true })
          );
        } catch (error) {
          console.debug('[Frequently Bought Together] Cart UI refresh skipped', error);
        }
      }

      removeCard(card) {
        card.classList.add('is-removing');

        window.setTimeout(() => {
          card.remove();

          if (!this.querySelector('.fbt-mini__card')) {
            this.classList.add('is-empty');

            window.setTimeout(() => {
              this.hidden = true;
            }, 180);
          }
        }, 180);
      }
    }

    customElements.define('fbt-compact', FbtCompact);
  }
  } catch(e) { console.error(e); }
})();

})();
